// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2k61G","name":"Header_name__2qBeb","birthday":"Header_birthday__3ucQE","skeleton":"Header_skeleton__24GfP"};